// extracted by mini-css-extract-plugin
export default {"sizeXs":".25em","sizeSm":".5em","sizeMd":"1em","sizeLg":"1.5em","sizeXl":"2em"};